export const iconFontAwesomeSecurityPersonMilitaryPointing = (
	<i className="fa-solid fa-person-military-pointing"></i>
);
